<div class="app-sidebar__overlay" (click)="closeMobileSidebar()"></div>
<div class="sticky" [ngClass]="{ 'sticky-pin': scrolled }">
  <aside class="app-sidebar sidebar-scroll">
    <div style="overflow-y: auto; overflow-x: hidden; height: 100%;">
      <div class="main-sidebar-header active" routerLink="/dashboard">
        <a class="desktop-logo logo-light active"><img src="./assets/img/brand/logos.png" class="main-logo" alt="logo"></a>
        <a class="desktop-logo logo-dark active"><img src="./assets/img/brand/sistemasblanco.png" class="main-logo" alt="logo"></a>
        <a class="logo-icon mobile-logo icon-light active"><img src="./assets/img/brand/logocm.png" alt="logo"></a>
        <a class="logo-icon mobile-logo icon-dark active"><img src="./assets/img/brand/logos.png" alt="logo"></a>
      </div>
      <div class="main-sidemenu">
        <div class="app-sidebar__user clearfix">
          <div class="dropdown user-pro-body">
            <div class="">
              <img alt="user-img" class="avatar avatar-xl brround"
                src="{{foto}}"><span
              class="avatar-status profile-status bg-green"></span>
            </div>
            <div class="user-info">
              <h4 class="font-weight-semibold mt-3 mb-0">{{nombre}}</h4>
              <span class="mb-0 text-muted">{{profileName | uppercase }}</span><br>
              <span class="mb-0 text-muted">{{sucursal}}</span>
            </div>
          </div>
        </div>
        <ul class="side-menu">
          <!-- left-arrow -->
          <div class="slide-left disabled" id="slide-left"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191"
            width="24" height="24" viewBox="0 0 24 24">
        <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" /></svg></div>
        <!-- 1st level Menu  -->
        @for (menuItem of menuItems; track menuItem) {
          <li class="slide"
            [ngClass]="{ active: menuItem.active ,'is-expanded': menuItem.active}">
            @if (menuItem.headTitle) {
              <div class="side-item side-item-category">{{menuItem.headTitle}}</div>
            }
            <!-- link -->
            @if (menuItem.type === 'link' ) {
              <a class="side-menu__item " [routerLink]="[menuItem.path] " [ngClass]="{ active: menuItem.active ,'is-expanded': menuItem.active}" ng-reflect-router-link-active-options
                (click)="toggleNavActive(menuItem); closeMobileSidebar()">
                <div class="">
                  <i class="material-icons-two-tone side-menu__icon">{{menuItem.icon}}</i>
                </div>
                <span class="side-menu__label">{{menuItem.title}} </span>
                <span class="badge bg-{{menuItem.badgeClass}} text-light" >{{menuItem.badgeValue}}</span>
              </a>
            }
            <!-- sub -->
            @if (menuItem.type === 'sub') {
              <a class="side-menu__item " [routerLink]="null"
                (click)="toggleNavActive(menuItem)" [ngClass]="{ active: menuItem.active ,'is-expanded': menuItem.active}">
                <div class="">
                  <i class="material-icons-two-tone side-menu__icon">{{menuItem.icon}}</i>
                </div>
                <span class="side-menu__label">{{menuItem.title}}</span>
                <i class="angle fe fe-chevron-down"></i>
              </a>
            }
            <!-- 2nd level menu -->
            @if (menuItem.children) {
              <ul class="slide-menu" [ngClass]="{active: menuItem.active}">
                @for (childrenItem of menuItem.children; track childrenItem) {
                  <li class="sub-slide"
                    [ngClass]="{active: childrenItem.active, 'is-expanded': childrenItem.active}">
                    <!-- Sub -->
                    @if (childrenItem.type === 'sub') {
                      <a href="javascript:void(0)" class="slide-item has-sub is-expanded" [ngClass]="{active: childrenItem.active}"
                        (click)="toggleNavActive(childrenItem)">
                        <span class="sub-side-menu__label">{{childrenItem.title}}</span>
                        @if (menuItem.children) {
                          <i class="sub-angle fe fe-chevron-{{childrenItem.active ? 'down' : 'right'}}"
                          ></i>
                        }
                      </a>
                    }
                    <!-- Link -->
                    @if (childrenItem.type === 'link') {
                      <a [routerLink]="!childrenItem.type ? null : [childrenItem.path]" class="slide-item"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileSidebar()">
                        <span>{{childrenItem.title}}</span>
                      </a>
                    }
                    @if (childrenItem.children) {
                      <ul class="sub-slide-menu"
                        [ngClass]="{active: childrenItem.active}">
                        @for (childrenSubItem of childrenItem.children; track childrenSubItem) {
                          <li
                            [ngClass]="{active: childrenSubItem.active}">
                            <!-- link -->
                            @if (childrenSubItem.type === 'link') {
                              <a class="slide-item ms-3"
                                [routerLink]="!childrenSubItem.type ? null : [childrenSubItem.path]"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact : true}" (click)="closeMobileSidebar()">
                                <span>{{childrenSubItem.title}}</span>
                              </a>
                            }
                          </li>
                        }
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
      <!-- right-arrow  -->
      <div class="slide-right" id="slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24"
        height="24" viewBox="0 0 24 24">
      <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" /></svg></div>
    </div>
  </div>
</aside>
</div>
